import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'services/localization';

interface Props {
	value: string | null;
	onChange: (trackingId: string) => void;
}

const TrackingIdInput = (props: Props) => {
	const { value, onChange } = props;
	const { t } = useTranslation();

	const handleTrackingIdChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e.target.value);
	};

	return (
		<TextField
			value={value}
			onChange={handleTrackingIdChange}
			variant="outlined"
			label={t('delivery.trackingId', 'Tracking ID')}
			fullWidth
			size="small"
			InputLabelProps={{ shrink: true }}
		/>
	);
};

export default TrackingIdInput;
